var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.campos,"clearable":"","outlined":"","dense":"","item-text":"tipo","item-value":"id","hide-details":"","label":"Status"},on:{"click:clear":_vm.clearStatus},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})
}
var staticRenderFns = []

export { render, staticRenderFns }